// for albums, locations, photos
import {
    SET_LOADING,
    SET_ERROR,
    CLEAR_ERROR,
} from '../mutation-types';
import axios from 'axios';

export default {
    /**
     * States
     */
    state: {
        albumMain: null,
        albumLocation: null,
        albumPhoto: null,
        gallery: null,
        endpoint: '',
        title: '',
    },

    /**
     * Mutations
     */
    mutations: {
        // having info about album + photos of the album
        setAlbumMain(state, payload) {
            state.albumMain = payload;
        },

        setAlbumLocation(state, payload) {
            state.albumLocation = payload;
        },

        setAlbumPhoto(state, payload) {
            state.albumPhoto = payload;
        },

        setGallery(state, payload) {
            state.gallery = payload;
        },

        setTitle(state, payload) {
            // console.log('SET lng: ', payload);
            state.title = payload;
        },


    },

    /**
     * Getters
     */
    getters: {
        albumMain: state => state.albumMain,
        albumLocation: state => state.albumLocation,
        albumPhoto: state => state.albumPhoto,
        gallery: state => state.gallery,
        title (state) {
            return state.title;
        },

    },

    /**
     * Actions
     */
    actions: {
        fetchAlbum({ commit, getters }, payload) {
            commit(SET_LOADING, true);
            commit(CLEAR_ERROR);
            // console.log('store fetchItem: ', payload);
            // type + id (ie: location, photo, album);
            axios.get(payload)
                .then((response) => {
                    commit(SET_LOADING, false);
                    // console.log('RESPONSE: ' , response.data.metas);
                    if(response.data !== undefined) {
                        commit('setAlbumMain', response.data);
                        commit('setTitle', response.data.name);
                        // set meta description, meta keywords

                        document.head.querySelector('meta[name=description]').content = response.data.metas.meta_description;
                        document.head.querySelector('meta[name=keywords]').content = response.data.metas.meta_keywords;
                        document.title = response.data.metas.meta_title;
                    } else {
                        // console.log('STORE error fetching album: ', this.getters.loading, this.getters.error);
                    }
                    // console.log('home store items: ', this.getters.items, response.data);
                    // console.log('home store items: ',getters);

                })
                .catch((error) => {
                    commit(SET_LOADING, false);
                    commit(SET_ERROR, error.response.data.errors.error);
                    // console.log('STORE error fetching album: ', error.response.data.errors.error);
                    // console.log('STORE error fetching album: ', this.getters.loading, this.getters.error);
                });
        },

        fetchPhoto({ commit, getters }, payload) {
            commit(SET_LOADING, true);
            commit(CLEAR_ERROR);
            // console.log('store fetchPhoto: ', payload.endpoint, payload);
            if(payload.type === 'photo') {
                // type + id (ie: location, photo, album);
                axios.get(payload.endpoint)
                    .then((response) => {
                        commit(SET_LOADING, false);
                        // console.log('RESPONSE: ' , response.data.photo);

                        if(response.data !== undefined) {
                            commit('setAlbumPhoto', response.data);
                            commit('setTitle', response.data.photo.album.name + ' ' + response.data.photo.location.title);
                            // set meta description, meta keywords
                            document.head.querySelector('meta[name=description]').content = response.data.metas.meta_description;
                            document.head.querySelector('meta[name=keywords]').content = response.data.metas.meta_keywords;
                            document.title = response.data.metas.meta_title;
                        }

                    })
                    .catch((error) => {
                        // console.log('STORE error fetching photo: ', error);
                        commit(SET_LOADING, false);
                        commit(SET_ERROR, error.response.data.errors);
                        // commit(SET_ERROR, error.response.data.errors.error);
                    });
            } else {
                // console.log('STORE fetch photo: ', data)
            }
        },

        fetchLocation({ commit, getters }, payload) {
            // console.log('time: ', Date.now());
            commit(SET_LOADING, true);
            commit(CLEAR_ERROR);
            // if reset, then will not work when you navigate from photo
            // to location on dropdown
            /*commit('setLat', '');
            commit('setLng', '');*/
            // console.log('store fetchLocation: ', payload);
            // type + id (ie: location, photo, album);
            axios.get(payload)
                .then((response) => {
                    commit(SET_LOADING, false);
                    // console.log('RESPONSE location: ' , response.data.metas);

                    if(response.data !== undefined) {
                        commit('setAlbumLocation', response.data);
                        commit('setLat', response.data.location.lat);
                        commit('setLng', response.data.location.lng);
                        commit('setTitle', response.data.location.name);

                        // set meta description, meta keywords
                        document.head.querySelector('meta[name=description]').content = response.data.metas.meta_description;
                        document.head.querySelector('meta[name=keywords]').content = response.data.metas.meta_keywords;
                        document.title = response.data.metas.meta_title;

                        commit('setPagination', response.data.photos);
                        commit('setPaginate', true);
                    }

                })
                .catch((error) => {
                    console.log('STORE error fetching location: ',error.response.data.errors.error);
                    commit(SET_LOADING, false);
                    commit(SET_ERROR, error.response.data.errors.error);
                });
        },

        fetchGallery({ commit, getters }, payload) {
            commit(SET_LOADING, true);
            commit(CLEAR_ERROR);

            // console.log('store fetchGallery: ', payload, this.getters);
            // type + id (ie: location, photo, album);
            axios.post(payload.endpoint, payload)
            // axios.get(payload)
                .then((response) => {
                    commit(SET_LOADING, false);
                    // console.log('RESPONSE: ' , response.data);

                    if(response.data !== undefined) {
                        commit('setGallery', response.data);
                        commit('setPagination', response.data.photos);
                        commit('setPaginate', true);
                        if(typeof(response.data.metas.albumName) !== 'undefined') {
                            commit('setTitle', response.data.metas.albumName);
                        }
                        // console.log('getter pagination: ', this.getters.pagination);

                        // set meta description, meta keywords
                        document.head.querySelector('meta[name=description]').content = response.data.metas.meta_description;
                        document.head.querySelector('meta[name=keywords]').content = response.data.metas.meta_keywords;
                        document.title = response.data.metas.meta_title;
                    }

                })
                .catch((error) => {
                    commit(SET_LOADING, false);
                    // console.log('STORE error fetching gallery: ',error);
                    commit(SET_ERROR, error);
                    // commit(SET_ERROR, error.response.data.message);
                    // commit(SET_ERROR, error.response.data.errors.error);
                });
        },

        /*
        search gallery by keyword
         */
        fetchGalleryFilter({ commit }, payload) {
            commit(SET_LOADING, true);
            commit(CLEAR_ERROR);

            let data = {
                field: payload.field,
                keyword: payload.value
            };

            axios.post(payload.endpoint, data)
                .then((response) => {
                    commit('setGallery', response.data);
                    commit('setPagination', response.data.photos);

                    commit('setPaginate', true);
                    // no records ?
                    if(response.data.error !== '') {
                        console.log('error: ', response.data.error);
                    }

                    document.head.querySelector('meta[name=description]').content = response.data.metas.meta_description;
                    document.head.querySelector('meta[name=keywords]').content = response.data.metas.meta_keywords;
                    document.title = response.data.metas.meta_title;
                    // console.log('STORE fetch gallery: ', response.data, this.getters.items);
                })
                .catch((error) => {
                    commit(SET_LOADING, false);
                    commit(SET_ERROR, error.response);
                    console.log('error search: ', error);
                });
        },

        // payload: enpoint, page, type(gallery, locations)
        // getResultStore
        getPaginatedItems({ commit }, payload) {
            // console.log('get result store: ', payload);
            if (typeof payload.page === 'undefined') {
                page = 1;
            }
            if(payload.type === 'gallery') {
                axios.post(payload.endpoint, payload)
                .then((response) => {
                    // console.log('paginated items: ', response.data);
                    if(payload.type === 'gallery') {
                        commit('setGallery', response.data);
                        commit('setPagination', response.data.photos);
                    }
                    else if(payload.type === 'albumLocation') {
                        commit('setAlbumLocation', response.data);
                        commit('setPagination', response.data.photos);
                    }

                    commit('setPaginate', true);
                    document.head.querySelector('meta[name=description]').content = response.data.metas.meta_description;
                    document.head.querySelector('meta[name=keywords]').content = response.data.metas.meta_keywords;
                    document.title = response.data.metas.meta_title;
                })
                .catch((error) => {
                    commit(SET_ERROR, error.response);
                });
            } else {
            // this.endpoint += '?results?page=' + page;
            axios.get(payload.endpoint)
                .then((response) => {
                    // console.log('paginated items: ', response.data);
                    if(payload.type === 'gallery') {
                        commit('setGallery', response.data);
                        commit('setPagination', response.data.photos);
                    }
                    else if(payload.type === 'albumLocation') {
                        commit('setAlbumLocation', response.data);
                        commit('setPagination', response.data.photos);
                    }

                    commit('setPaginate', true);
                    document.head.querySelector('meta[name=description]').content = response.data.metas.meta_description;
                    document.head.querySelector('meta[name=keywords]').content = response.data.metas.meta_keywords;
                    document.title = response.data.metas.meta_title;
                })
                .catch((error) => {
                    commit(SET_ERROR, error.response);
                });
            }
        },

    }

};



// WEBPACK FOOTER //
// ./src/store/modules/photos.js